import { LegalLayout, useCompany } from "./LegalLayout";

export default function CharteAvis() {
  const COMPANY = useCompany();
  return (
    <LegalLayout title="Charte des avis" updated="octobre 2026" testid="reviews-charter-page">
      <p>Conformément à l'article L111-7-2 du Code de la consommation, {COMPANY.site} informe ses clients des modalités de collecte, de contrôle et de publication des avis.</p>

      <h2>1. Qui peut déposer un avis ?</h2>
      <p>Seuls les clients ayant acheté et reçu le produit sur {COMPANY.site} peuvent déposer un avis. Lorsqu'une commande est marquée comme livrée, le client reçoit par e-mail un lien personnel, valable 90 jours et utilisable une seule fois. Un seul avis peut être déposé par commande. Aucune contrepartie n'est accordée en échange d'un avis.</p>

      <h2>2. Contrôle et modération</h2>
      <p>Chaque avis est relu par {COMPANY.site} avant publication, généralement sous quelques jours. Un avis peut être refusé uniquement s'il contient des propos injurieux, diffamatoires, discriminatoires ou hors sujet, des données personnelles, ou s'il ne concerne pas le produit. Les avis négatifs sont publiés au même titre que les avis positifs. Le contenu d'un avis n'est jamais modifié.</p>

      <h2>3. Publication</h2>
      <p>Les avis sont publiés par ordre chronologique, du plus récent au plus ancien, avec la note, le titre, le commentaire, le prénom et l'initiale du nom choisis par le client ainsi que la date de dépôt. La note moyenne est calculée sur l'ensemble des avis publiés.</p>

      <h2>4. Vos droits</h2>
      <p>Vous pouvez demander la suppression de votre avis à tout moment en écrivant à <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>. Le traitement de vos données est décrit dans notre <a href="/politique-confidentialite">Politique de confidentialité</a>.</p>
    </LegalLayout>
  );
}
